import { useRouter } from 'next/router';
import { HTMLAttributes, PropsWithChildren, useEffect } from 'react';
import HeaderMobile from '@/dashboard/components/Header/HeaderMobile';
import { useMaterialMedia } from '@/dashboard/hooks/useMaterialMedia';
import { globalDataStore } from '@/dashboard/store/globalDataStore';
import { useWindowSize } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header/Header';
import { withAuthRequired } from '../utils/withAuthRequired';

type DashboardLayoutProps = HTMLAttributes<HTMLDivElement> & {
  mainClassName?: any;
  layoutContainerClassName?: string;
};

const DashboardLayout = (props: DashboardLayoutProps) => {
  const { className, children, mainClassName, layoutContainerClassName } = props;
  const router = useRouter();
  const {
    actions: { updateGlobalQueryParams },
  } = globalDataStore();
  const windowSize = useWindowSize();
  const { isMobile } = useMaterialMedia();

  /**
   * effects
   */
  useEffect(() => {
    makeRequests();
  }, []);

  /**
   * methods
   */
  const makeRequests = () => {
    const { queryUserId } = router.query;
    if (queryUserId) {
      updateGlobalQueryParams({ queryUserId });
    }
  };

  return (
    <div className={`flex flex-col bg-white ${className}`}>
      {isMobile ? <HeaderMobile /> : <Header />}

      {/* subtract <header> and <footer> and <py-10> in order to the content is not enough high, the footer can display normal */}
      <div className={clsx('flex-grow py-10', mainClassName)}>
        <main
          style={{
            minHeight: windowSize.height ? Number(windowSize.height || 0) - 76 - 142 - 10 * 4 * 2 + 'px' : '550px',
          }}
          className={clsx('mx-auto max-w-7xl lg:px-8', { 'px-6': !isMobile, 'px-3': isMobile }, layoutContainerClassName)}
        >
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default withAuthRequired(DashboardLayout);
